import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { theme } from '../../theme/colors';
import { buildNearbyEventsPath } from '../../utils/eventProximity';

/**
 * Minimal dashboard prompt in the civic sidebar. Shown when we know the
 * user's ZIP (proximity sort) or at least their state (state-scoped list).
 */
export default function NearbyEventsLink({ zipcode, stateAbbr = '' }) {
  const to = buildNearbyEventsPath(zipcode, stateAbbr);
  if (!to) return null;

  return (
    <Box
      component={RouterLink}
      to={to}
      className="xl:min-w-[320px] 2xl:min-w-[360px]"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 2,
        py: 1.5,
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        bgcolor: '#ffffff',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'border-color 0.15s, background-color 0.15s',
        '&:hover': {
          borderColor: 'rgba(4, 120, 87, 0.35)',
          bgcolor: 'rgba(4, 120, 87, 0.03)',
        },
      }}
    >
      <EventOutlinedIcon sx={{ color: theme.primary, fontSize: 20, flexShrink: 0 }} />
      <Typography
        sx={{ flex: 1, minWidth: 0, fontSize: 14, fontWeight: 700, color: '#0f172a', lineHeight: 1.35 }}
        noWrap
      >
        See events in your area
      </Typography>
      <ChevronRightIcon sx={{ color: theme.primary, fontSize: 22, flexShrink: 0 }} />
    </Box>
  );
}
